import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";

@Injectable()
export class FileUploadModalLayoutService {
  private _open$: Subject<void> = new Subject<void>();
  private _close$: Subject<void> = new Subject<void>();

  get open$(): Observable<void> {
    return this._open$.asObservable();
  }

  get close$(): Observable<void> {
    return this._close$.asObservable();
  }

  openModal(): void {
    this._open$.next();
  }

  closeModal(): void {
    this._close$.next();
  }
}
